type IconProps = { className?: string };

export const LinkIcon = ({ className = "rt-ic" }: IconProps) => (
  <svg className={className} viewBox="0 0 20 20" aria-hidden="true">
    <path d="M8.4 11.6 11.6 8.4" />
    <path d="M7.2 9.1 5.6 10.7a2.7 2.7 0 0 0 3.8 3.8l1.6-1.6" />
    <path d="M12.8 10.9l1.6-1.6a2.7 2.7 0 0 0-3.8-3.8L9 7.1" />
  </svg>
);

export const AnchorIcon = () => (
  <svg className="rt-ic rt-ic--anchor" viewBox="0 0 20 20" aria-hidden="true">
    <circle cx="10" cy="4.6" r="1.7" />
    <path d="M10 6.6v9" />
    <path d="M6.6 8.6h6.8" />
    <path d="M4 11.6c0 3.1 2.7 4.6 6 4.6s6-1.5 6-4.6" />
  </svg>
);

export const PlaneIcon = () => (
  <svg className="rt-ic rt-ic--anchor" viewBox="0 0 20 20" aria-hidden="true" style={{ fill: "#fff", stroke: "none" }}>
    <path d="M10 3c.6 0 1.1.7 1.1 1.6v3.1l4.9 2.9v1.7l-4.9-1.4v3.2l1.7 1.2V17L10 16.2 7.2 17v-1.7l1.7-1.2v-3.2L4 12.3v-1.7l4.9-2.9V4.6C8.9 3.7 9.4 3 10 3Z" />
  </svg>
);

export const TruckIcon = () => (
  <svg className="rt-ic rt-ic--anchor" viewBox="0 0 20 20" aria-hidden="true">
    <path d="M2.6 5.6h8v7.2h-8z" />
    <path d="M10.6 8.4h3.2l2.6 2.6v1.8h-5.8z" />
    <circle cx="6" cy="14.4" r="1.5" />
    <circle cx="13.6" cy="14.4" r="1.5" />
  </svg>
);
